var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogout(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 2.5H12.25C16.25 2.5 18.75 5 18.75 9V14.0625H10.9375C10.425 14.0625 10 14.4875 10 15C10 15.5125 10.425 15.9375 10.9375 15.9375H18.75V21C18.75 25 16.25 27.5 12.25 27.5H9.0125C5.0125 27.5 2.5125 25 2.5125 21V9C2.5 5 5 2.5 9 2.5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3002 14.0623L21.7127 11.4748C21.5252 11.2873 21.4377 11.0498 21.4377 10.8123C21.4377 10.5748 21.5252 10.3248 21.7127 10.1498C22.0752 9.7873 22.6752 9.7873 23.0377 10.1498L27.2252 14.3373C27.5877 14.6998 27.5877 15.2998 27.2252 15.6623L23.0377 19.8498C22.6752 20.2123 22.0752 20.2123 21.7127 19.8498C21.3502 19.4873 21.3502 18.8873 21.7127 18.5248L24.3002 15.9373H18.7502V14.0623H24.3002Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.ffd6b68ce6395a4fe02209205fc480ca.svg";
export { ForwardRef as ReactComponent };